import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import {
  ModuleAssessmentBatchDate,
  ModuleAssessmentDateUpdate,
} from 'src/app/models/assessment/assessmentsubmission.model';
import { SchoolModuleBatch } from 'src/app/models/module/moduledetails';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';
declare const $: any;

@Component({
  selector: 'app-view-module-batch',
  templateUrl: './view-module-batch.component.html',
  styleUrls: ['./view-module-batch.component.css'],
})
export class ViewModuleBatchComponent implements OnInit {
  batchID: any;
  moduleBatch: SchoolModuleBatch = {
    id: 0,
    name: '',
    startDate: undefined,
    endDate: undefined,
    moduleID: 0,
    meetingID: ''
  };
  moduleID: any;
  showSave: boolean = false;
  isEdit: boolean = false;
  batchTitle = 'Batch Details';
  adminActions: AdminAction[] = [];
  fdate;
  minDate: Date;
  isAssessmentEditable = false;
  asssmentDate: ModuleAssessmentBatchDate[] = [];
  assessmentDateUpdate: ModuleAssessmentDateUpdate = {
    batchID: 0,
    moduleID: 0,
    classID: 0,
    assessmentID: 0,
    id: 0,
    startTime: undefined,
    stopTime: undefined,
    name: '',
  };
  constructor(
    public headerinfo: ComponentheaderService,
    private activatedroute: ActivatedRoute,
    public modulemanager: ModulemanagementService,
    private toastr: ToastrService,
    public assessmentManager: AssessmentmanagerService,
    public util: UtilService,
    private router: Router
  ) {
    headerinfo.setHeaderDisplay('Loading Batch...', [], []);
  }

  async ngOnInit() {
    try {
      this.headerinfo.pageLoadingStarted(this);

      this.batchID = this.activatedroute.snapshot.queryParams.batchID;
      this.moduleID = this.activatedroute.snapshot.queryParams.moduleId;

      if (this.batchID <= 0) {
        this.batchTitle = 'New Batch';
        this.showSave = true;
      } else {
        this.moduleBatch = await this.modulemanager
          .getBatchFromID(this.batchID)
          .toPromise();
        this.isAssessmentEditable = true;
        this.fdate = new Date(this.moduleBatch.endDate)
          .toISOString()
          .slice(0, 10);
        console.log(this.fdate);
        this.isEdit = true;
        this.adminActions.push({
          displaytext: 'Edit Batch',
          callback: this.editBatch.bind(this),
          classes: ['fas', 'fas fa-edit'],
        });
        this.asssmentDate = await this.assessmentManager
          .getBatchCourseAssessments(this.moduleID, this.batchID)
          .toPromise();
        this.asssmentDate.forEach((element) => {
          if (element.startTime == '0001-01-01T00:00:00') {
            element.startTime = null;
          }
          if (element.stopTime == '0001-01-01T00:00:00') {
            element.stopTime = null;
          }
          return element;
        });
      }

      this.moduleBatch.moduleID = this.moduleID;
      console.log(this.moduleBatch);
      console.log(this.asssmentDate);

      this.headerinfo.setHeaderDisplay(
        'Module Batches',
        [
          { displaytext: 'School', route: `/user/schoolhome` },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.moduleID },
          },
          {
            displaytext: 'Batches',
            route: '/user/modulebatches',
            params: { moduleID: this.moduleID },
          },
          {
            displaytext: this.batchTitle,
            route: '/user/viewmodulebatch',
            params: { batchID: this.batchID },
          },
        ],
        this.adminActions
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  async SaveBatch() {
    try {
      if (this.moduleBatch.name == '') {
        this.toastr.error('Batch Name is required');
        return;
      }
      if (this.moduleBatch.startDate == undefined) {
        this.toastr.error('Invalid Start Date');
        return;
      }
      if (
        this.moduleBatch.endDate < this.moduleBatch.startDate ||
        this.moduleBatch.endDate == undefined
      ) {
        this.toastr.error('Invalid End Date');
        return;
      }

      await this.modulemanager
        .saveModuleBatch(this.moduleBatch)
        .toPromise()
        .then((res:any) => {
          this.toastr.success('Batch Saved.');
          if (!this.isEdit) {
            window.location.assign(`/user/viewmodulebatch?batchID=${res.id}&moduleId=${res.moduleID}`)
          } else {
            const queryParams = { moduleID: this.moduleBatch.moduleID };
            this.router.navigate(['/user/modulebatches'], {
              queryParams: queryParams,
            });
          }
        });
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }
  editBatch() {
    this.showSave = true;
  }
  setMinDate() {
    this.minDate = this.moduleBatch.startDate;
  }

  editAssessmentPopUpBatch(item: any) {
    $('#updateAssessmentDate').modal('show');
  }

  async submitAssessmentBatch(item: any) {
    debugger;
    this.assessmentDateUpdate = item;
    this.assessmentDateUpdate.batchID = this.moduleBatch.id;
    console.log(this.assessmentDateUpdate);
    this.asssmentDate = await this.assessmentManager
      .updateBatchCourseAssessments(this.assessmentDateUpdate)
      .toPromise();
    this.toastr.success('Updated');
    $('#updateAssessmentDate').modal('hide');
  }
  onRowEditInit(assessmentItem: ModuleAssessmentBatchDate, index: number) {
    assessmentItem.editable = true;
    this.asssmentDate[index] = assessmentItem;
  }
}
